/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreManagementEditItemResponse } from './StoreManagementEditItemResponse';

export type StoreManagementEditItemResponseApiRespoonse = {
    data?: StoreManagementEditItemResponse;
    status?: StoreManagementEditItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace StoreManagementEditItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

